/**
 * Class description
 *
 * Created: 2017-11-17
 * @author jonas
 */

import * as PIXI from "pixi.js";
import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TextureAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/TextureAsset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/BitmapFontAsset";
import {SpineAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/SpineAsset";
import {ReelSymbolName} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolName";
import {WinterHoardGameConfig} from "./WinterHoardGameConfig";


export class WinterHoardGameAssets {

    public static INTRO_BACKGROUND:string = "resources/images/Intro_BG.jpg";
    public static INTRO_LOGO:string = "resources/images/introLogo.png";
    //public static LAYOUT:string = "resources/images/image.png";

    public static MAIN_GAME_BACKGROUND:string = "mainBackground";
    public static FREE_SPIN_BACKGROUND:string = "freespinBackground";
    static FREE_SPIN_TRANSITION_BACKGROUND:string = "screens/freespinTransitionBackground";

    static REEL_BACKGROUND:string = "reel/reelBackground";
    static REEL_FG:string = "reelFrame";
    static SHAMAN_INTRO:string ="shaman/shamanIntro";


    public static getSymbolStateTexturePath(symbolName:string, stateName:string | null = null):string {
        if(stateName == null || stateName == "") {
            return symbolName + "/" + symbolName;
        }
        return symbolName + "/" + symbolName + "_" + stateName;
    }

    public static getSymbolStateTextures(symbolName:string, stateName:string | null = null):PIXI.Texture[] {
        if(symbolName === ReelSymbolName.SCATTER) {
            if(stateName === WinterHoardGameConfig.instance.SYMBOL_STATES.plus.keyword) {
                return GameResources.getTextures("scatterNearWin");
            }
            if(stateName === WinterHoardGameConfig.instance.SYMBOL_STATES.normal.keyword) {
                return GameResources.getTextures("scatterLanding");
            }
            if(stateName === WinterHoardGameConfig.instance.SYMBOL_STATES.trigger.keyword) {
                return GameResources.getTextures("scatterLanding");
            }
        }
        return GameResources.getTextures(WinterHoardGameAssets.getSymbolStateTexturePath(symbolName, stateName));
    }

    static getMultiplierTag(multiplier:number):PIXI.Texture {
        if(multiplier > 1) {
            return GameResources.getTextures("multiplierTag/x" + multiplier)[0];
        }
        return PIXI.Texture.EMPTY;

    }

    public static RESOURCES_GROUPS:IResourcesGroupConfig = {
        intro : [
            {
                name : "fonts",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new BitmapFontAsset("numbersOpenSans800", "fonts/bitmapfonts/NumbersOpenSans800.fnt"),
                    new BitmapFontAsset("BHmultiplier", "fonts/bitmapfonts/BHmultiplier.fnt"),
                    new BitmapFontAsset("numbersWinCountUp", "fonts/bitmapfonts/NumbersWinCountUp.fnt"),
                    new BitmapFontAsset("bhWinCountUp", "fonts/bitmapfonts/BH_CountUpNumber.fnt")
                ]
            },
            {
                name : "intro",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("intro0", "sheets/intro/intro0.json"),
                    new SpineAsset("introTransform", "Spine/intro_horde.json"),
                    new SpineAsset("introMultiplier", "Spine/Intro_prairie.json"),
                    new SpineAsset("introSuper", "Spine/intro_super_bonus.json")
                ]

            },
            {
                name : "introJpeg",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("introJpeg0", "sheets/introJpeg/introJpeg0.json")
                ]
            }
        ],

        main : [
            {
                name : "main",
                assets : [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),
                    new TextureAsset("main2", "sheets/main/main2.json"),
                    new TextureAsset("main3", "sheets/main/main3.json"),
                    new TextureAsset("main4", "sheets/main/main4.json"),
                    new TextureAsset("main5", "sheets/main/main5.json")
                    //new TextureAsset("main6", "sheets/main/main6.json"),
                    //new TextureAsset("main7", "sheets/main/main7.json"),
                    //new TextureAsset("main8", "sheets/main/main8.json")
                    //new TextureAsset("main9", "sheets/main/main9.json")
                    //new TextureAsset("main10", "sheets/main/main10.json")
                ],
                animations: {
                    "landscapeHolder" : "meters/MeterHolderLandscape",
                    "portraitHolder" : "meters/MeterHolderPortrait",
                    "m1FramePortrait" : "meters/portraitMultiplier",
                    "m1FrameLandscape" : "meters/landscapeMultiplier",

                    "mysterySymbolAnim" : "M_symbol/Mystery_symbol_",

                    "blankMeterLandscape" : "meters/Landscape/Meter_Blank",
                    "buffaloCoverLandscape" : "meters/Landscape/cover/buffaloCover",
                    "cougarCoverLandscape" : "meters/Landscape/cover/cougarCover",
                    "coyoteCoverLandscape" : "meters/Landscape/cover/coyoteCover",
                    "eagleCoverLandscape" : "meters/Landscape/cover/eagleCover",
                    "pronghornCoverLandscape" : "meters/Landscape/cover/pronghornCover",

                    "buffaloRevealLandscape" : "meters/Landscape/reveal/buffaloReveal",
                    "cougarRevealLandscape" : "meters/Landscape/reveal/cougarReveal",
                    "coyoteRevealLandscape" : "meters/Landscape/reveal/coyoyteReveal",
                    "eagleRevealLandscape" : "meters/Landscape/reveal/eagleReveal",
                    "pronghornRevealLandscape" : "meters/Landscape/reveal/pronghornReveal",


                    "blankMeterPortrait" : "meters/Portrait/Meter_Blank",
                    "buffaloCoverPortrait" : "meters/Portrait/cover/buffaloCover",
                    "cougarCoverPortrait" : "meters/Portrait/cover/cougarCover",
                    "coyoteCoverPortrait" : "meters/Portrait/cover/coyoteCover",
                    "eagleCoverPortrait" : "meters/Portrait/cover/eagleCover",
                    "pronghornCoverPortrait" : "meters/Portrait/cover/pronghornCover",

                    "buffaloRevealPortrait" : "meters/Portrait/reveal/bufalloReveal",
                    "cougarRevealPortrait" : "meters/Portrait/reveal/cougarReveal",
                    "coyoteRevealPortrait" : "meters/Portrait/reveal/coyoteReveal",
                    "eagleRevealPortrait" : "meters/Portrait/reveal/eagleReveal",
                    "pronghornRevealPortrait" : "meters/Portrait/reveal/prongHornReveal",

                    "meterBlast" : "Feature_M1_transform/meter_blast/meter_blast_",

                    "meterFlip" : "Feature_M1_transform/meter_flip/Meter_flip_",
                    "energyBlast" : "Feature_M1_transform/moving_energy/Energy_",
                    "reelNearWin" : "Anticipation/Anticipation_",

                    //"bw_coming" : "big_wins/bw_coming",
                    //"bw_is" : "big_wins/bw_is",
                    //"bw_herd" : "big_wins/bw_Herd",
                    //"bw_crack0" : "big_wins/crack",
                    //"bw_crack1" : "big_wins/crack1",
                    "bigwinGlow" : "big_wins/glow_halfsize",
                    "bigWinCoin0" : "big_wins/coinFountain/bronze/Bronze_",
                    "bigWinCoin1" : "big_wins/coinFountain/silver/Silver_",
                    "bigWinCoin2" : "big_wins/coinFountain/gold/Gold_",

                    "ringGlowEffect" : "Fs_intro/ring"
                }
            },
            {
                name : "mainYellow",
                assets : [
                    new TextureAsset("mainYellow0", "sheets/mainYellow/mainYellow0.json")
                ],
                animations: {
                    "reelFrame" : "Reelframe",
                    "winEnergy" : "betline/Betlinetest_0",
                    "betlineNumberGlow1" : "betlineGlow/1_glow",
                    "betlineNumberGlow2" : "betlineGlow/2_glow",
                    "betlineNumberGlow3" : "betlineGlow/3_glow",
                    "betlineNumberGlow4" : "betlineGlow/4_glow",
                    "betlineNumberGlow5" : "betlineGlow/5_glow",
                    "betlineNumberGlow6" : "betlineGlow/6_glow",
                    "betlineNumberGlow7" : "betlineGlow/7_glow",
                    "betlineNumberGlow8" : "betlineGlow/8_glow",
                    "betlineNumberGlow9" : "betlineGlow/9_glow",
                    "betlineNumberGlow10" : "betlineGlow/10_glow",
                    "betlineNumberGlow11" : "betlineGlow/11_glow",
                    "betlineNumberGlow12" : "betlineGlow/12_glow",
                    "betlineNumberGlow13" : "betlineGlow/13_glow",
                    "betlineNumberGlow14" : "betlineGlow/14_glow",
                    "betlineNumberGlow15" : "betlineGlow/15_glow",
                    "betlineNumberGlow16" : "betlineGlow/16_glow",
                    "betlineNumberGlow17" : "betlineGlow/17_glow",
                    "betlineNumberGlow18" : "betlineGlow/18_glow",
                    "betlineNumberGlow19" : "betlineGlow/19_glow",
                    "betlineNumberGlow20" : "betlineGlow/20_glow",
                    "betlineNumberGlow21" : "betlineGlow/21_glow",
                    "betlineNumberGlow22" : "betlineGlow/22_glow",
                    "betlineNumberGlow23" : "betlineGlow/23_glow",
                    "betlineNumberGlow24" : "betlineGlow/24_glow",
                    "betlineNumberGlow25" : "betlineGlow/25_glow",
                    "betlineNumberGlow26" : "betlineGlow/26_glow",
                    "betlineNumberGlow27" : "betlineGlow/27_glow",
                    "betlineNumberGlow28" : "betlineGlow/28_glow",
                    "betlineNumberGlow29" : "betlineGlow/29_glow",
                    "betlineNumberGlow30" : "betlineGlow/30_glow",
                    "betlineNumberGlow31" : "betlineGlow/31_glow",
                    "betlineNumberGlow32" : "betlineGlow/32_glow",
                    "betlineNumberGlow33" : "betlineGlow/33_glow",
                    "betlineNumberGlow34" : "betlineGlow/34_glow",
                    "betlineNumberGlow35" : "betlineGlow/35_glow",
                    "betlineNumberGlow36" : "betlineGlow/36_glow",
                    "betlineNumberGlow37" : "betlineGlow/37_glow",
                    "betlineNumberGlow38" : "betlineGlow/38_glow",
                    "betlineNumberGlow39" : "betlineGlow/39_glow",
                    "betlineNumberGlow40" : "betlineGlow/40_glow",
                    "betlineNumber1" : "normal/1",
                    "betlineNumber2" : "normal/2",
                    "betlineNumber3" : "normal/3",
                    "betlineNumber4" : "normal/4",
                    "betlineNumber5" : "normal/5",
                    "betlineNumber6" : "normal/6",
                    "betlineNumber7" : "normal/7",
                    "betlineNumber8" : "normal/8",
                    "betlineNumber9" : "normal/9",
                    "betlineNumber10" : "normal/10",
                    "betlineNumber11" : "normal/11",
                    "betlineNumber12" : "normal/12",
                    "betlineNumber13" : "normal/13",
                    "betlineNumber14" : "normal/14",
                    "betlineNumber15" : "normal/15",
                    "betlineNumber16" : "normal/16",
                    "betlineNumber17" : "normal/17",
                    "betlineNumber18" : "normal/18",
                    "betlineNumber19" : "normal/19",
                    "betlineNumber20" : "normal/20",
                    "betlineNumber21" : "normal/21",
                    "betlineNumber22" : "normal/22",
                    "betlineNumber23" : "normal/23",
                    "betlineNumber24" : "normal/24",
                    "betlineNumber25" : "normal/25",
                    "betlineNumber26" : "normal/26",
                    "betlineNumber27" : "normal/27",
                    "betlineNumber28" : "normal/28",
                    "betlineNumber29" : "normal/29",
                    "betlineNumber30" : "normal/30",
                    "betlineNumber31" : "normal/31",
                    "betlineNumber32" : "normal/32",
                    "betlineNumber33" : "normal/33",
                    "betlineNumber34" : "normal/34",
                    "betlineNumber35" : "normal/35",
                    "betlineNumber36" : "normal/36",
                    "betlineNumber37" : "normal/37",
                    "betlineNumber38" : "normal/38",
                    "betlineNumber39" : "normal/39",
                    "betlineNumber40" : "normal/40"
                }
            },
            {
                name : "mainHighQuality",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("mainHighQuality0", "sheets/mainHighQuality/mainHighQuality0.json"),
                    new TextureAsset("mainHighQuality1", "sheets/mainHighQuality/mainHighQuality1.json")
                ],
                animations: {}
            },
            {
                name : "mainBGGrass",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("mainBGGrass0", "sheets/mainBGGrass/mainBGGrass0.json")
                ],
                animations: {}
            },
            {
                name : "mainBGCloud",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("mainBGCloud0", "sheets/mainBGCloud/mainBGCloud0.json"),
                    new TextureAsset("mainBGCloud1", "sheets/mainBGCloud/mainBGCloud1.json"),
                    new TextureAsset("mainBGCloud2", "sheets/mainBGCloud/mainBGCloud2.json")

                ],
                animations: {}
            },
            {
                name : "mainJpeg",
                assets : [
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                    new TextureAsset("mainJpeg3", "sheets/mainJpeg/mainJpeg3.json"),
                    new TextureAsset("mainJpeg4", "sheets/mainJpeg/mainJpeg4.json"),
                    //new TextureAsset("mainJpeg5", "sheets/mainJpeg/mainJpeg5.json")
                ],
                animations: {
                    "mainSky" : "bg_sky_jpeg",
                    "fsSky" : "fs_sky_jpeg",
                    "meterEnergy" : "Feature_M1_transform/meter_energy/meter_energy_",
                }
            },
            {
                name : "freespin",
                assets : [
                    new TextureAsset("freespin0", "sheets/freespin/freespin0.json"),
                    new TextureAsset("freespin1", "sheets/freespin/freespin1.json")
                ],
                animations: {
                    "bar" : "bar",
                    "fsintroParticle" : "IntroFs/introPT",
                    "TRANSFORMButton" : "IntroFs/Buffalohorde",
                    "MULTIPLIERButton" : "IntroFs/PrairieMultiplier",
                    "SUPERButton" : "IntroFs/SuperBonusMode",
                    "fsOutroFREESPIN_TRANSFORM" : "IntroFs/Buffalohorde",
                    "fsOutroFREESPIN_MULTIPLIER" : "IntroFs/PrairieMultiplier",
                    "fsOutroFREESPIN_COMBINED" : "IntroFs/SuperBonusMode",
                    "outroRedGlow" : "OutroFs/redGlow",
                }
            },
            {
                name : "spine",
                assets : [
                    new SpineAsset("logoSpine", "Spine/logo.json"),

                    new SpineAsset("symSpineL1", "Spine/L1.json"),
                    new SpineAsset("symSpineL2", "Spine/L2.json"),
                    new SpineAsset("symSpineL3", "Spine/L3.json"),
                    new SpineAsset("symSpineL4", "Spine/L4.json"),
                    new SpineAsset("symSpineL5", "Spine/L5.json"),

                    new SpineAsset("symSpineM1", "Spine/M1.json"),
                    new SpineAsset("symSpineM2", "Spine/M2.json"),
                    new SpineAsset("symSpineM3", "Spine/M3.json"),
                    new SpineAsset("symSpineM4", "Spine/M4.json"),
                    new SpineAsset("symSpineM5", "Spine/M5.json"),

                    new SpineAsset("scatterRays", "Spine/scatter_glow_rays.json"),
                    new SpineAsset("countUpSparkle", "Spine/countup_spark.json"),

                    new SpineAsset("bigWinText", "Spine/Big_win.json"),
                    new SpineAsset("bgSpine", "Spine/bg_fs_idle.json"),

                    new SpineAsset("meterEnergy", "Spine/meter_glow.json"),
                    new SpineAsset("addExtraFs", "Spine/2_freespins.json"),
                    new SpineAsset("fsIntense", "Spine/fs_intense.json")
                ]
            },
            {
                name : "symbols",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json")

                ],
                animations: {
                    "M1" : "M1/M1",
                    "M2" : "M2/M2",
                    "M3" : "M3/M3",
                    "M4" : "M4/M4",
                    "M5" : "M5/M5"
                }
            },
            {
                name : "wildAnimation",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("wildAnimation0", "sheets/wildAnimation/wildAnimation0.json")

                ],
                animations: {
                    "wildIdle" : "wild_idle/wild_idle_",
                    "wildWin" : "wild_win/wild_win_",
                    "wildLanding" : "wild_landing/Wild_landing_"
                }
            },
            {
                name : "scatterAnimation",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("scatterAnimation0", "sheets/scatterAnimation/scatterAnimation0.json")

                ],
                animations: {
                    "scatterLanding" : "S_landing_trigger/S_landing_",
                    "scatterNearWin" : "S_anticipation/S_anti_",
                }
            }
        ]
    };


}
